"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import { useLocalizedStringFormatter } from 'react-aria';
import locales from '../../../../../../_virtual/_.locale.json@95341064edeb0e38b66d786dbd62955c.mjs';
import { ValidationResultEntry } from '../ValidationResultEntry/ValidationResultEntry.mjs';
import { Button } from '../../../Button/Button.mjs';
import { ContextualHelp } from '../../../ContextualHelp/ContextualHelp.mjs';
import { ContextualHelpTrigger } from '../../../ContextualHelp/components/ContextualHelpTrigger/ContextualHelpTrigger.mjs';
import { Heading } from '../../../Heading/Heading.mjs';

const ValidationResultButton = (props) => {
  const { policyValidationResult, isDisabled, isEmptyValue, className } = props;
  const translate = useLocalizedStringFormatter(locales);
  const validationResultComponents = policyValidationResult?.ruleResults?.filter((r) => {
    return isEmptyValue ? !r.isValid : true;
  }).map((result, index) => {
    return /* @__PURE__ */ jsx(
      ValidationResultEntry,
      {
        result
      },
      `${result.identifier}-${index}`
    );
  });
  return /* @__PURE__ */ jsxs(ContextualHelpTrigger, { children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        "data-component": "showPasswordRules",
        isDisabled,
        className
      }
    ),
    /* @__PURE__ */ jsxs(ContextualHelp, { children: [
      /* @__PURE__ */ jsx(Heading, { children: translate.format("password.requirements.heading") }),
      validationResultComponents
    ] })
  ] });
};

export { ValidationResultButton };
//# sourceMappingURL=ValidationResultButton.mjs.map
